const initBootstrapCarousel = async () => {
    // Dynamic import
    const elements = document.querySelectorAll('[data-bs-ride="carousel"]');
    if (! elements.length) {
        return;
    }
    const {default: Carousel} = await import('bootstrap/js/dist/carousel');
    // Instantiation
    const carouselTriggerList = [].slice.call(elements);
    carouselTriggerList.map((carouselTriggerEl) => {
        return new Carousel(carouselTriggerEl);
    });
};

export default class BootstrapCarousel {

    static init() {
        initBootstrapCarousel();
    }

}
